import React, { Component } from 'react';
//import {Select} from 'react-select';
import Properties             from '../components/Properties'

import { TableRow,
    TableColumn,
    ExpansionPanel,
    ExpansionList,
    Grid, Cell,
    DialogContainer,
    Card,
    SelectionControlGroup,
  CardTitle,
  CardText,Button} from 'react-md';

//import  MultiSelectReact  from 'multi-select-react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'

import crossIcon from '../images/png/crossIcon.png';
import plusIcon from '../images/png/plus.png';
import styles from '../css/styles.css.js';

import SelectBox from '../components/SelectBox';
import Loader from '../components/Loader';

import  '../css/QuizCreationStyle.css';
import { NotificationManager } from 'react-notifications';
import { AppSetting, AppProperties } from '../common/functions';
import LoadingSpinner from '../components/LoadingSpinner.js';
import { AppContext } from '../AppContext.js';
import SFCourseSectionEnrollDialog from '../SF/SFComponents/SFCourseSectionEnrollDialog/SFCourseSectionEnrollDialog.jsx';



const sectionListMap = function (mapping_data)
{
    var condensedList = {};
    if(mapping_data && mapping_data.length > 0)
    {
        mapping_data.forEach(element => {
          let sectionName = element.section_name;
          if(element.section_name === ''){
              sectionName = 'No Sections'
          }
            if(condensedList[element.course_id] === undefined || condensedList[element.course_id] === null)
                {
                    var new_element = {
                      course_id : element.course_id,
                      course_name : element.course_name,
                      userid : element.userid,
                      section_name : [],
                      section_id : [],
                    };
                    new_element.section_name.push(sectionName);
                    new_element.section_id.push(element.section_id)

                    condensedList[element.course_id] = new_element;



                }
                else
                {

                    condensedList[element.course_id].section_name.push(sectionName);
                    condensedList[element.course_id].section_id.push(element.section_id);
                }
        });
    }

    var condensedArray = Object.keys(condensedList).map(function (key) { return condensedList[key]; });
    return condensedArray;

}


export default class SectionEnrollment extends Component {
    AppSetting =  AppSetting();
    appProperties = AppProperties();
    uiSettings = this.appProperties.getUISettings();

    static contextType = AppContext

    constructor(props){
        super(props);
        this.state = {
          tempUserId: '',
          enrollments: [],
          courses: [],
          sections: [],
          insertCourse: '',
          insertSection: [],
          visible: false,
          addMode : true,
          condensedArray: [],
          page_loading: false,
          dialog_loading: false,
          disabled: true,
          fontSize:this.uiSettings.fontSize
        };

        this.selectBoxCourseHandleChange =  this.selectBoxCourseHandleChange.bind(this);
        this.deleteMapping = this.deleteMapping.bind(this);
        this.addMapping = this.addMapping.bind(this);
        
        this.selectedBadgeClicked =  this.selectedBadgeClicked.bind(this);
    }

    prepareData(){
        this.setState({page_loading:true});
        const payload = {
            userId: this.state.tempUserId

        }
        let responsePromise = this.props.apiService({method: 'post',
        url: '/getStudentSectionEnrollment',
        data: payload});
        responsePromise.then(res => {
            console.log(res.data.data.enrollmentData);
            let enrollmentData = res.data.data.enrollmentData;
            if (enrollmentData) {
                enrollmentData = enrollmentData.filter(courseEnrolled => !courseEnrolled.is_special_course);
                var condensedArray = sectionListMap(enrollmentData);
                this.setState({
                    enrollments: enrollmentData,
                    condensedArray: condensedArray,
                });
            }
            this.setState({
                page_loading : false,
            })
            if (this.context && this.context.updateStudentEnrolledCourses) {
                this.context.updateStudentEnrolledCourses(res.data.data.enrollmentData);
            }
        })
    }

    UNSAFE_componentWillMount(){
        this.prepareData();
        this.uiSettings.refreshUISettings();
        this.setState({fontSize:this.uiSettings.fontSize});
    }

    addMappingService(props){
        this.errorMessageHide();
        let responsePromise = this.props.apiService({method: 'post',
        url: '/addStudentSectionEnrollment',
        data: props});
        responsePromise.then(res => {
            this.setState({page_loading:false});
            if(res.data.message !== null && res.data.message !== ""){
                if(res.data.message.toLowerCase().indexOf("duplicate")>=0){
                    NotificationManager.error("Duplicate entry. Section already Enrolled","Error",4000);
                }else if(res.data.message.indexOf("MaxSectionLimitReached")>=0){
                    //this.setState({errorMessage: "You cannot enroll to more than one Section",
                    //errorType:'error'});
                    NotificationManager.error("You cannot enroll in more than one section for every course","Error",4000);
                }
                else{
                    NotificationManager.error(res.data.message,"Error",4000);
                }
            } else {
                NotificationManager.success("Section(s) Added","Success",4000);
            }
            this.prepareData();
            this.hide();
        });
    }

    addMapping(){
        this.errorMessageHide();
        console.log("Add Enrollment :" + this.state.insertSection);

        if(this.state.insertCourse === undefined || this.state.insertCourse === ''){
            this.setState({disabled:true});
            return;
        }
        else if(this.state.insertSection === undefined || this.state.insertSection.length===0)
        {
            this.setState({disabled:true});
            return;
        }else{
            this.setState({page_loading:true});
        for (var i=0;i<this.state.insertSection.length;i++){
            const payload = {
                userId: this.state.tempUserId,
                course_id: this.state.insertCourse,
                section_id: this.state.insertSection[i]
            }
            this.addMappingService(payload);
        }
    }
    }

    errorMessageHide(){
        console.log("errorType");
        var tempErrortype = "";
        this.setState({
            errorMessage: tempErrortype,
            errorType:tempErrortype,
        })
    }
    deleteMapping(courseid,sectionid){
        this.errorMessageHide();
        console.log("Deleting Enrollment");
        const payload = {
            userId: '',
            course_id: courseid,
            section_id:sectionid,
        } ;
        this.setState({page_loading:true});
        this.props.apiService(
          {method: 'post',
          url: '/deleteStudentSectionEnrollment',
          data: payload}
          )
          .then(res => {
            console.log(res);

            this.setState({page_loading:false});
            if(res.data.message !== null && res.data.message !== ""){
                this.setState({errorMessage:res.data.message,
                errorType:'error'});
            } else {
                this.setState({errorMessage:'Section Deleted',
                errorType:'success'});
            }
            this.prepareData();
          });

    }
    delete (course_id,section_id) {
        this.errorMessageHide();
        confirmAlert({
          title: 'Do you really want to delete this Section?',
          message: 'Press "Yes" to submit',
          buttons: [
            {
              label: 'Yes',
              onClick: () => this.deleteMapping(course_id,section_id)
            },
            {
              label: 'No',
            }
          ]
        })
      };



    loadCourseData(){
        this.setState({dialog_loading:true});
        this.props.apiService({
            method: 'post',
            url: '/getAllCoursesEnroll'

          })
          .then(res => {
            this.setState({
            courses: res.data.data.course_names?.filter(course => course.status === 1),
            insertSection: [],
            dialog_loading: false
          });
          })
    }

    loadSectionData(course_id){
        this.setState({dialog_loading:true});
        const payload = {
            course_id: course_id

        }
        console.log("Course id : ",payload);
        this.props.apiService({
            method: 'post',
            url: '/getAllSectionsEnroll',
            data: payload
        })
        .then(res => {
            var tempSectionList = [];
          var tempSectionArr = res.data.data.section_names;
          if(tempSectionArr != null){
            this.setState({
                sections: tempSectionArr,
              });
          }
        }).finally(() => {
            this.setState({
                dialog_loading: false
            })
        })
    }

    selectBoxCourseHandleChange(event) {

        var course_id = parseInt(event.target.value,10);
        if(isNaN(course_id)){
            this.setState({insertCourse: '',
            disabled:true});
        }else{
        this.setState({insertCourse: course_id});
        this.loadSectionData(course_id);
        }
      };

      selectedBadgeClicked(event) {

        var temp_id =[];

        var section_id = parseInt(event.target.value,10);
        temp_id.push(section_id);
        if(isNaN(section_id)){
            this.setState({insertSection: '',
            disabled:true});
        }else{
        this.setState({insertSection: temp_id,
            disabled:false});
       // this.loadSectionData(course_id);
        }

     /*   var tempInsertSection = [];
        for(var i = 0; i < optionsList.length; i++){
          if(optionsList[i].value === true){ 
            var tempInsert = {};
            tempInsert["id"] = optionsList[i].id;
            tempInsertSection.push(tempInsert);
          }
        }
            this.setState({
            disabled: tempInsertSection.length===0,
            //sections: optionsList,
            insertSection: tempInsertSection,
         });
*/
      }

      optionClicked(optionsList) {
        this.setState({
            sections: optionsList,

           });
      }


    show = () => {
        this.errorMessageHide();
        this.setState({
            sections:[],
            insertCourse:'',
            visible: true });
        this.loadCourseData();
      };

    hide = () => {
        this.setState({  visible: false,
        addMode: true });
    };

//UI Settings
    onFontSizeChange = (fontSize) =>{
        this.setState({fontSize});
        this.uiSettings.setFontSize(fontSize);
    }

    render() {

        const selectedOptionsStyles = {
            
            color: "#FFFFFF",
            backgroundColor: "#bb0000"
          };
          const optionsListStyles = {
            backgroundColor: "#bb0000",
            color: "#FFFFFF"
          };

        let button = null;
        let disabledbutton = null;
        if(this.state.addMode){
            disabledbutton = <button style= {styles.disabledButton} 
             hidden = {!this.state.disabled}>Add</button>
            button = <button style= {styles.addButton} onClick = {this.addMapping} hidden = {this.state.disabled}>Add</button>
        }
        else{
            button = <button style= {styles.addButton} onClick = {this.updateMapping}>Update Mapping</button>
        }
        var cancelButton = <button style= {styles.cancelButton} onClick = {this.hide}>Cancel</button>

        const actions = [];
        actions.push(disabledbutton);
        actions.push(button);
        actions.push(cancelButton);

        if(this.state.page_loading) {
            return <LoadingSpinner />
        }
        

        return (
           <div><h1 style={{color: '#576271'}} className='text-size-larger'>
               Settings
               </h1>

            {this.state.visible ? 
                <SFCourseSectionEnrollDialog 
                    open={this.state.visible}
                    handleCloseEnrollDialog={() => this.setState({visible: false})}
                    onMappingComplete={() => {
                        this.setState({visible: false});
                        this.prepareData();
                    }}
                    showCancelBtn={true}
                />
            : null}

               {/* { <DialogContainer
                        id="simple-action-dialog"
                        visible={this.state.visible}
                        onHide={this.hide}
                        actions={actions}
                        title={this.appProperties.schoolMode?"Enroll in a new Standard":"Enroll in a new Course/Section"}
                        width="400px"
                        contentStyle={{height : "320px"}}
                        titleStyle={{color: '#576271', fontSize : "18px"}}
                        >

                <div style={{float: "left",color:"#576271", paddingLeft:"15px",paddingRight: "10px"}}>

                <br></br>
                      <SelectBox columns={this.state.courses.filter(course => !course.is_lti_enabled)} keys={["course_id","course_name"]}
                            style={styles.select}
                            selectBoxcallBack={this.selectBoxCourseHandleChange} 
                            labeltxt={this.appProperties.schoolMode?"Step 1: Choose a Standard":"Step 1: Choose a Course"}
                            />
                </div>
                <br></br>
                <div 
                style={{float: "left",color:"#576271", paddingLeft:"15px",
                paddingRight: "10px", width: "250px"}}>
                <br></br>
                <SelectBox
                columns={this.state.sections}
                style={styles.select}
                keys={["section_id","section_name"]}
                labeltxt="Step 2: Choose a Section:"
                selectBoxcallBack={this.selectedBadgeClicked}
               
              />
        
        
                {this.state.disabled=true}
                </div>
                <div>
                    <Loader loading={this.state.dialog_loading} style={{width:"400px",height:"320px"}}/>
                </div>
                </DialogContainer>
              } */}
            <div>
            </div>
            <br/><br/>
                <Grid>
                    {
                        this.appProperties.enableLTI?
                        null:
                        <Cell size={6}>
                        <Card  style={{borderRadius:"6px",}}>
                            <CardTitle title="Sections Enrolled" />
                            {/* <CardText>
                    <div>After you have set up your {this.appProperties.schoolMode?"standard":"course"}(s) go to “Assignments” in the left menu to see your assignments.</div>
                            </CardText> */}
                            <div style={{borderColor:"#576271"}}>
                            <Grid>
                                <Cell size={4} phoneSize={2} tabletSize={2}>
                                <div  style={{color: '#576271'}} className='text-size-larger' >
                                {this.appProperties.schoolMode?"Standard List":"Course Enrollments"}</div>
                                </Cell>
                                <Cell size={8} phoneSize={4} tabletSize={6}>
                                <div style={{float:'right'}}>
                                <Button  primary  raised className="buttonColour" flat 
                               // style={{background: "transparent",border: "none"}}
                                onClick = {() => {
                                    // this.show
                                    this.setState({visible: true})
                                }}>
                                {//<img src={plusIcon} name ="Add" alt="Add"/>
                                }{this.appProperties.schoolMode?"Enroll in a new standard":"Enroll in a new course"}
                                </Button>
                                </div>
                                </Cell>
                            </Grid>
                            <ExpansionList>
                            {(this.state.condensedArray.length <= 0) ?
                            <div style = {{marginLeft: '15px', marginRight : '15px', marginBottom : '15px'}}>
                                {this.appProperties.schoolMode?"No Standard/Sections enrolled.":"No Courses/Sections enrolled."}
                            </div>
                            :
                            this.state.condensedArray.map((mapping, i) =>
                            <ExpansionPanel style={{
                                boxShadow: 'none',
                                // boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75); !important',
                                borderBottomLeftRadius:'6px',
                                borderBottomRightRadius: '6px',
                            }} key={i} className="md-panel-secondary-label" label={mapping.course_name} footer={null}>
                                <div>Sections</div>
                                <table>
                                <tbody>
                                {mapping.section_name.map((rowData,index) =>
                                <TableRow key={i*100+index} >
                                    <TableColumn style={{width:"200px"}}>{rowData}</TableColumn>
                                    <TableColumn >
                                    <button 
                                        style={{background: "transparent",border: "none"}}
                                        onClick ={() =>this.delete(mapping.course_id, mapping.section_id[index])}>
                                        <img src={crossIcon} alt="Delete"  style={{maxWidth:'30px'}}
                                        />
                                        </button>
                                    </TableColumn>
                                </TableRow>
                                )}
                                </tbody>
                                </table>
                                
                            </ExpansionPanel>)}
                            </ExpansionList>
                            </div>
                            {/* <CardText>
                                <div>{this.appProperties.schoolMode?
                                'Don’t see your standard? Add it by clicking the red button that says "Enroll in a new standard".'
                                :'Don’t see your course? Add it by clicking the red button that says "Enroll in a new course".'}
                                </div>
                            </CardText> */}
                        </Card>
                </Cell>
                    }
                    
                <Cell size={6}>
                    <Card style={{borderRadius:"6px",boxShadow:"5px"}}>
                        <CardTitle title="UI Settings" />
                        <CardText>
                            <SelectionControlGroup
                                id="selection-control-group-font-size"
                                name="font-size"
                                type="radio"
                                inline
                                label="Font Size"
                                value={this.state.fontSize}
                                onChange={this.onFontSizeChange}
                                controls={[{
                                    label: 'x-small',
                                    value: 'x-small'
                                },
                                {
                                    label: 'small',
                                    value: 'small'
                                }, 
                                {
                                    label: 'medium',
                                    value: 'medium'
                                }, {
                                    label: 'large',
                                    value: 'large'
                                }, 
                                {
                                    label: 'x-large',
                                    value: 'x-large'
                                }
                                ]}
                            />
                            
                        </CardText>
                    </Card>
                </Cell>
            </Grid>
        </div>

        );
     }
}
